window.getCookieValue = function(cookieName) {
    let cookieArray = document.cookie.split(';');
    for(let i = 0; i < cookieArray.length; i++) {
        let cookiePair = cookieArray[i].split('=');
        if(cookieName == cookiePair[0].trim()) {
            return cookiePair[1];
        }
    }
    return null;
}

window.getExpoValues = function(){
    let cookieExponeaValue = getCookieValue('__exponea_etc__');
    var expo1 = cookieExponeaValue !== null ? cookieExponeaValue : '';
    var expo2 = '';

    let cookieConsentValue = getCookieValue('cookie_consent');
    if(cookieConsentValue !== null){
        let decodedCookieValue = decodeURIComponent(cookieConsentValue);
        let cookieObject = JSON.parse(decodedCookieValue);
        if(cookieObject.ad_storage && cookieObject.ad_storage == 'granted'){
            expo2 = 'granted';
        }
    }

    var foundexponeascript = false;
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.indexOf('exponea.min.js') > -1) {
            foundexponeascript = true;
            break;
        }
    }

    if(!foundexponeascript){
        expo2 = '';
        expo1 = '';
    }

    return {
        expo1: expo1,
        expo2: expo2
    };
}


$(document).ready(function () {

    $(".game__btn").on("click", function (event) {
        event.preventDefault();
    });

    // Prihlasenie sa do sutaze
    $(".form").on("submit", function (event) {
        if ($(this).hasClass("reset")) {
            return true;
        }

        event.preventDefault();

        var expovalues = getExpoValues();
        var expo1 = expovalues.expo1;
        var expo2 = expovalues.expo2;

        if( $('.form input[name="expo1"]').length == 0){
            $('.form').append('<input type="hidden" name="expo1" value="'+(expo1)+'" />');
            $('.form').append('<input type="hidden" name="expo2" value="'+(expo2)+'" />');
        }

        var form = $(this);

        $.ajax({
            method: "POST",
            url: '/chcem-sa-zapojit',
            data: form.serialize(),
            beforeSend: function () {
                form.find(".form__label--error").removeClass(
                    "form__label--error"
                );
                form.find(".form__text--error").removeClass(
                    "form__text--error"
                );
                form.find(".form__check-label--error").removeClass(
                    "form__check-label--error"
                );
                form.find(".form__radio-label--error").removeClass(
                    "form__radio-label--error"
                );
                form.find(".form__msg").hide();
                form.find(".klient_msg").text("").hide();
                form.find(".form__triple--error").removeClass(
                    "form__triple--error"
                );

                $('.loader').css('display', 'flex');
            },
            error: function (data) {

                $('.loader').css('display', 'none');
                $.each(data.responseJSON.errors, function (key, value) {
                    if (key) {
                        if (key == "podmienky") {
                            form.find("#podmienky")
                                .next()
                                .addClass("form__check-label--error");
                        } else if (key == "info_1") {
                            form.find("#info_1")
                                .next()
                                .addClass("form__check-label--error");
                        } else if (key == "info_2") {
                            form.find("#info_2")
                                .next()
                                .addClass("form__check-label--error");
                        } else if (key == "ucet") {
                            form.find("input[type=radio]")
                                .next()
                                .addClass("form__radio-label--error");
                        } else if (key == "phone") {
                            form.find("input[name=" + key + "]")
                                .addClass("form__text--error")
                                .parent()
                                .next()
                                .fadeIn(100)
                                .text(value);
                        } else if (key == "klient") {
                            form.find(".klient_msg").text(value).fadeIn(100);
                            form.find(".form__triple").addClass(
                                "form__triple--error"
                            );
                        } else {
                            form.find("input[name=" + key + "]")
                                .addClass("form__text--error")
                                .next()
                                .fadeIn(100)
                                .text(value);
                        }
                        form.find("#info")
                            .next()
                            .addClass("form__check-label--error");
                    }
                });
            },
            success: function (response) {
                // resetneme formulár
                form[0].reset();

                window.dataLayer.push({
                    event: "exponea_track",
                    exponea_ev: "contact_form_facebook",
                    exponea_data: {
                        person_name: response.name,
                        first_name: response.user.first_name,
                        last_name: response.user.last_name,
                        agreement: response.user.marketing == 1,
                        competition_agreement: true,
                        phone: response.user.phone,
                        version: "1",
                        flag_client: response.client,
                        email: response.user.email,
                        site_type: "RB_FBGAMING",
                        utm_source: response.utm ? response.utm.source : null,
                        utm_medium: response.utm ? response.utm.medium : null,
                        utm_campaign: response.utm ? response.utm.campaign : null,
                        utm_term: response.utm ? response.utm.term : null,
                        utm_content: response.utm ? response.utm.content : null,
                        event_name: "Parádna súťaž hokej 2026",
                        zip: response.user.zip,
                    },
                });

                if (response.user.marketing == 1) {
                    window.dataLayer.push({
                        event: "sutazny_formular",
                        form: "sutazny_formular",
                        person_name:
                            response.user.first_name +
                            " " +
                            response.user.last_name,
                        phone: response.user.phone,
                    });

                    window.dataLayer.push({
                        event:
                            response.client == "client"
                                ? "sutazny_formular_klient"
                                : "sutazny_formular_prospect",
                        form: "sutazny_formular",
                        person_name:
                            response.user.first_name +
                            " " +
                            response.user.last_name,
                        phone: response.user.phone,
                    });
                } else {
                    window.dataLayer.push({
                        event: "sutazny_formular_nesuhlas",
                        form: "form",
                    });
                }

                setTimeout(function(){
                    window.location.href = "/bonus";
                }, 200);
            },
        });

        return false;
    });

    $(".form__radio").change(function (e) {
        if ($(this).is(":checked")) {
            $(this)
                .parents(".form__box")
                .find(".form__radio-label--error")
                .removeClass("form__radio-label--error");
        }
    });

    $("#info_1, #info_2, #podmienky").change(function (e) {
        if ($(this).is(":checked")) {
            $(this)
                .parents(".form__box")
                .find(".form__check-label--error")
                .removeClass("form__check-label--error");
        }
    });

    $(".btn--chcem").click(function (e) {
        e.preventDefault();

        window.dataLayer.push({
            event: "mam_zaujem",
            button: "mam_zaujem",
        });

        $(".done__wrapper--gratulujeme").hide();
        $(".done__wrapper--info").fadeIn(400);
    });

    $homebtn = $('.home__btn');
    if($homebtn.length > 0){
        $homebtn.on('click', function(e){
            window.dataLayer.push({
                event: "start",
                button: "start"
            });
        });
    }

    $homebtn2 = $('.home__ralf-link');
    if($homebtn2.length > 0){
        $homebtn2.on('click', function(e){
            window.dataLayer.push({
                event: "start_img",
                button: "start_img"
            });
        });
    }

    if ($(".form__triple").length > 0) {
        var ts;
        $(".form__triple")
            .bind("touchstart", function (e) {
                ts = e.originalEvent.touches[0].clientX;
            })
            .bind("touchend", function (e) {
                var te = e.originalEvent.changedTouches[0].clientX;
                if (ts > te + 5) {
                    $(".form__triple input:checked")
                        .prev()
                        .prev()
                        .prop("checked", true);
                } else if (ts < te - 5) {
                    $(".form__triple input:checked")
                        .next()
                        .next()
                        .prop("checked", true);
                }
            });
    }

    var game__fields = $('.ev-field');
    if(game__fields.length){
        game__fields.each(function(){
            $(this).on('click', function(e){
                e.preventDefault();
                var $this = $(this);
                $.get('/reveal/' + $(this).data('id'), function(m){

                    if(m.redirect){
                        $('.preloader')
                            .html('<div class="check"><img src="/images/cross.svg"></div>')
                            .css("display", "flex")
                            .hide()
                            .fadeIn('fast');
                        $('.preloader__wrapper').show();
                        setTimeout(function(){
                            window.location.href = m.redirect;
                        }, 2000);
                    } else {
                        $this.html('<img src="' + m.img + '">');
                        $('.game__score-box-value').html(m.score + '&nbsp;€');
                        var dots = $('.game__score-tries-dot');
                        if(m.score < 200 && !$(dots[0]).hasClass('game__score-tries-dot--active')){
                            $(dots[0]).addClass('game__score-tries-dot--active');
                            $('.game__score-tries-label strong').html('4/5');
                        }
                        if(m.score < 170 && !$(dots[1]).hasClass('game__score-tries-dot--active')){
                            $(dots[1]).addClass('game__score-tries-dot--active');
                            $('.game__score-tries-label strong').html('3/5');
                        }
                        if(m.score < 140 && !$(dots[2]).hasClass('game__score-tries-dot--active')){
                            $(dots[2]).addClass('game__score-tries-dot--active');
                            $('.game__score-tries-label strong').html('2/5');
                        }
                        if(m.score < 110 && !$(dots[3]).hasClass('game__score-tries-dot--active')){
                            $(dots[3]).addClass('game__score-tries-dot--active');
                            $('.game__score-tries-label strong').html('1/5');
                        }
                        if(m.score < 80 && !$(dots[4]).hasClass('game__score-tries-dot--active')){
                            $(dots[4]).addClass('game__score-tries-dot--active');
                            $('.game__score-tries-label strong').html('0/5');
                        }
                    }
                });
            });
        })
    }

    var game__words = $('.ev-word');
    if(game__words.length){
        game__words.each(function(){
            $(this).on('click', function(e){
                e.preventDefault();
                var $this = $(this);
                $.get('/answer/' + $(this).data('id'), function(m){
                    $('.preloader')
                        .html('<div class="check"><img src="/images/' +(m.status ? 'check' : 'cross') +'.svg"></div>')
                        .css("display", "flex")
                        .hide()
                        .fadeIn('fast');

                    $('.preloader__wrapper').show();
                    setTimeout(function(){
                        window.location.href = '/' + m.url;
                    }, 2000);
                });
            });
        });
    }

});
